export default "__VITE_ASSET__CqKYtpNf__"